import React from "react";
import "./Loader.css";
// import logo from "./logo.png";
import { useSelector } from "react-redux";
const Loader = () => {
  const siteData = useSelector(
    (state) => state.data.sitesetting?.siteSetting?.[0]?.data
  );
  return (
    <div className="global-loader">
      <img src={siteData?.logos?.[0]} alt="" className="loader-logo" />
    </div>
  );
};

export default Loader;
